<template>
  <ModalDialog
    ref="dialog"
    :title="title"
    icon="fa-exclamation-triangle"
    :showFooter="true"
    :submitting="submitting"
    closeTitle="Cancel"
    :submitTitle="submitTitle"
    @closed="onClosed"
    @submitted="onSubmitted">

    <FormGroup v-bind:form="form" :labelColumnSize="3">
      <FormRow label="Sheet Size (HxW)">
        <FormStaticLabel>{{calculatedSheetHeight}}mm x {{calculatedSheetWidth}}mm</FormStaticLabel>
      </FormRow>
      <FormRow label="From Top">
        <FormInputText type="number" addon="mm" v-model="measureFromTop" />
      </FormRow>
      <FormRow label="From Right">
        <FormInputText type="number" addon="mm" v-model="measureFromRight" />
      </FormRow>
      <FormRow label="From Bottom">
        <FormInputText type="number" addon="mm" v-model="measureFromBottom" />
      </FormRow>
      <FormRow label="From Left">
        <FormInputText type="number" addon="mm" v-model="measureFromLeft" />
      </FormRow>

      <FormRow label="Defect Size (HxW)">
        <FormStaticLabel>
          <span :class="{'text-danger': defectSizeHasError}">{{defectHeight}}mm x {{defectWidth}}mm </span>
          <Tooltip label="Measurements are invalid or exceed sheet size" v-if="defectSizeHasError"><i class="fas fa-exclamation-triangle text-danger"></i></Tooltip>
        </FormStaticLabel>
        
      </FormRow>
      

    </FormGroup>
  </ModalDialog>
</template>

<style scoped>

</style>

<script>
import _ from 'lodash'
import { v4 as uuidv4 } from 'uuid'

import form from '@/mixins/form'
import ModalDialog from '@/components/modalDialog.vue'
import modalDialog from '@/mixins/modalDialog'


export default {
  name: 'DefectEditDialog',
  mixins: [
    modalDialog,
    form
  ],
  components: {
    ModalDialog,
  },
  props: {
    sheetWidth: Number,
    sheetHeight: Number,
    isCreateMode: Boolean,
    isSheetRotated: Boolean
  },
  data() {
    return {
      form: {},
      submitting: false,

      defectId: '',
      measureFromTop: 0,
      measureFromRight: 0,
      measureFromBottom: 0,
      measureFromLeft: 0
    }
  },
  mounted() {
  },
  computed: {
    title() {
      return this.isCreateMode ? 'New Sheet Defect' : 'Edit Sheet Defect'
    },
    submitTitle() {
      return this.isCreateMode ? 'Create' : 'Update'
    },
    calculatedSheetWidth() {
      return this.isSheetRotated ? this.sheetHeight : this.sheetWidth
    },
    calculatedSheetHeight() {
      return this.isSheetRotated ? this.sheetWidth : this.sheetHeight
    },
    defectWidth() {
      return this.calculatedSheetWidth - parseInt(this.measureFromRight || 0) - parseInt(this.measureFromLeft || 0)
    },
    defectHeight() {
      return this.calculatedSheetHeight - parseInt(this.measureFromBottom || 0) - parseInt(this.measureFromTop || 0)
    },
    defectSizeHasError() {
      let top = parseInt(this.measureFromTop || 0)
      let right = parseInt(this.measureFromRight || 0)
      let bottom = parseInt(this.measureFromBottom || 0)
      let left = parseInt(this.measureFromLeft || 0)

      if(top < 0 || right < 0 || bottom < 0 || left < 0)
        return true
      if(top + bottom >= this.calculatedSheetHeight)
        return true
      if(left + right >= this.calculatedSheetWidth)
        return true

      return false
    }
  },
  methods: {
    show() {
      this.form = {}
      this.submitting = false

      if(this.isCreateMode)
        this.defectId = uuidv4()

      return modalDialog.methods.show.call(this, arguments)
    },
    onClosed() {
      this.modalClosed(null)
    },
    onSubmitted() {
      this.form = this.clearFormResponse()

      let top = parseInt(this.measureFromTop || 0)
      let left = parseInt(this.measureFromLeft || 0)

      this.modalClosed({
        id: this.defectId,
        x: left,
        y: top,
        width: this.defectWidth,
        height: this.defectHeight
      })
      this.hide()
    },
  }
}
</script>